import { useCallback, useState } from "react";

const useToast = () => {
    const [isOpen, setIsOpen] = useState(false);

    const triggerToast = useCallback(() => {
        setIsOpen(false);
        requestAnimationFrame(() => setIsOpen(true));
    }, []);

    return { isOpen, onOpenChange: setIsOpen, triggerToast };
};

export default useToast;
